export const TOKEN_KEY = 'Client@token';
export const USER = 'Client@user';
export const PASSWORD = 'Client@password';
export const USERID = 'Client@userId';
export const MODULES = 'Client@modulos';
export const THEME = 'Client@tema';
export const CONTRATO = 'Client@contrato';
export const CONTRATOS = 'Client@contratos';
export const USERCARGOID = 'Client@userCargoId';
export const USERSETORID = 'Client@userSetorId';
export const USERNAME = 'Client@username';
export const DATA = 'Client@data';
export const FIREBASE = 'Client@firebase';
export const FIRSTLOGIN = 'Client@firstLogin';

export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = token => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const getEmailLogin = () => {
  return localStorage.getItem(USER) != null ? localStorage.getItem(USER) : '';
}
export const setEmailLogin =  (value) => {
  localStorage.setItem(USER, value)
}
export const getPasswordLogin = () => {
  return localStorage.getItem(PASSWORD) != null ? localStorage.getItem(PASSWORD) : '';
}
export const setPasswordLogin =  (value) => {
  localStorage.setItem(PASSWORD, value)
}

export const getUserId = () => localStorage.getItem(USERID);
export const setUserId =  (value) => {
  localStorage.setItem(USERID, value)
}

export const getUsername = () => localStorage.getItem(USERNAME);
export const setUsername =  (value) => localStorage.setItem(USERNAME, value);

export const storeModules = (value) => {
  const jsonValue = JSON.stringify(value)
  localStorage.setItem(MODULES, jsonValue)
}
export const getModules = () => {
  const jsonValue = localStorage.getItem(MODULES)
  return jsonValue != null ? JSON.parse(jsonValue) : null;
}

export const storeData = (value) => {
  const jsonValue = JSON.stringify(value)
  localStorage.setItem(DATA, jsonValue)
}
export const getData = () => {
  const jsonValue =  localStorage.getItem(DATA)
  return jsonValue != null ? JSON.parse(jsonValue) : null;
}

export const getTheme =  () => localStorage.getItem(THEME);
export const setTheme = (value) => localStorage.setItem(THEME, value);

export const getContrato = () => localStorage.getItem(CONTRATO);
export const setContrato =  (value) => localStorage.setItem(CONTRATO, value);

export const setContratos = (value) => {
  const jsonValue = JSON.stringify(value)
  localStorage.setItem(CONTRATOS, jsonValue)
}
export const getContratos = () => {
  // {
  //   "id": 5524,
  //   "cliente_id": 3323,
  //   "bairro": "Bomsucesso",
  //   "cnpj": "057.944.137-78",
  //   "consultor": 9,
  //   "endereco": "Av Guilherme maxuel",
  //   "nome": "Patricia Torres Lobitzki Martins",
  //   "status": "Contrato Ativo",
  //   "tiporesiduo": "Kioto Reciclável"
  // }
  const jsonValue = localStorage.getItem(CONTRATOS)
  return jsonValue != null ? JSON.parse(jsonValue) : null;
}
export const getFirebase = () => localStorage.getItem(FIREBASE);
export const setFirebase = token => {
  localStorage.setItem(FIREBASE, token);
};

export const getUsuarioCargoId = () => localStorage.getItem(USERCARGOID);
export const setUsuarioCargoId =  (value) => localStorage.setItem(USERCARGOID, value);

export const getUsuarioSetorId = () => localStorage.getItem(USERSETORID);
export const setUsuarioSetorId =  (value) => localStorage.setItem(USERSETORID, value);
export const getFirstLogin = () => localStorage.getItem(FIRSTLOGIN);
export const setFirstLogin =  (value) => localStorage.setItem(FIRSTLOGIN, value);


export const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER)
  localStorage.removeItem(PASSWORD)
  localStorage.removeItem(USERID)
  localStorage.removeItem(CONTRATO)
  localStorage.removeItem(DATA)
  localStorage.removeItem(MODULES)
  localStorage.removeItem(CONTRATOS)
  localStorage.removeItem(FIREBASE)
};